import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=722e7a2e&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=722e7a2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722e7a2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('722e7a2e')) {
      api.createRecord('722e7a2e', component.options)
    } else {
      api.reload('722e7a2e', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=722e7a2e&scoped=true&", function () {
      api.rerender('722e7a2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2jtK7dq47GNVs/JS/comp/CookieBox.vue"
export default component.exports